


export default function SelectorDay({ isDesktop, day, isSelected, onClick }) {
	return (
		<div className={`rounded-[10px] p-[10px] cursor-pointer ${isSelected ? 'bg-[#CDE7FF]' : 'bg-white'}`} onClick={onClick}>
			<div className="font-Vazir-400 text-[16px] text-center">
				{day.week_day}
			</div>
			<div className="font-Vazir-400 text-[16px] p-[5px]"></div>
			<div className="font-Vazir-400 text-[16px] text-center">
				{day.j_date}
			</div>
		</div>
	)
}
